<template>
	<div class="outinsert">
		<div class="ininsert" v-html="protoluser">
			<!-- <rich-text :nodes=""></rich-text> -->

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				protoluser:''
			}
		},
		created() {
      document.title='用户协议'
			this.detail()
		},
		methods: {
			detail(){
        // console.log('123')
        // return
        console.log(this.api.userApi)
        console.log(this.api.userApi.ampapiuserAgreement)
        var $this = this
        let param = {}
        var qs = require('qs');
        let url = this.api.userApi.ampapiuserAgreement
        this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            console.log(result)
            $this.protoluser=result.data.user_agreement
          }).catch((error) => {
            console.warn(error)
            // $this.$toast('error');
          })

			}
		}
	}
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
	view{
		box-sizing: border-box;
		word-break: break-all;
	}
	::-webkit-scrollbar {
	  width: 0;
	  height: 0;
	  color: transparent;
	}
	.outinsert{
		font-size: 28*@vm_base;
		padding: 40*@vm_base;
		.ininsert{
			padding: 40*@vm_base;
			background: #FFFFFF;
			border-radius: 12*@vm_base;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/mypri/protoluser.vue